import React, { useEffect, useRef } from "react";
import {
  ChartComponent,
  SeriesCollectionDirective,
  SeriesDirective,
  Inject,
  DateTime,
  Legend,
  Tooltip,
  LineSeries,
  ColumnSeries,
  SplineSeries,
  Category,
} from "@syncfusion/ej2-react-charts";

const CustomChart = ({ data }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      if (chartRef.current) {
        chartRef.current.refresh(); // Refresh the chart on window resize
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // Ensure we have valid data before rendering
  if (!data || !data.chartData || !data.chartConfig || data.chartData.length === 0) {
    return <div>No data available for chart</div>;
  }

  return (
    <ChartComponent
      ref={chartRef} 
      background="#2d2d2d"
      primaryXAxis={{
        valueType: data.xAxisType || "Category",
        labelStyle: { color: "#e0e0e0" },
        majorGridLines: { width: 0 },
        edgeLabelPlacement: "Shift",
        labelIntersectAction: "Rotate45",
      }}
      primaryYAxis={{
        labelFormat: "{value}",
        rangePadding: "None",
        minimum: data.minValue !== undefined ? data.minValue : undefined,
        maximum: data.maxValue !== undefined ? data.maxValue : undefined,
        interval: data.interval !== undefined ? data.interval : undefined,
        majorTickLines: { width: 0 },
        lineStyle: { width: 0 },
        labelStyle: { color: "#e0e0e0" },
      }}
      tooltip={{
        enable: true,
        fill: "#2d2d2d",
        textStyle: { color: "#e0e0e0" },
      }}
      legendSettings={{
        visible: true,
        background: "#2d2d2d",
        textStyle: { color: "#e0e0e0" },
      }}
      titleStyle={{ color: "#e0e0e0" }}
      width="100%"
      height="100%"
    >
      <Inject
        services={[
          LineSeries,
          ColumnSeries,
          SplineSeries,
          DateTime,
          Category,
          Legend,
          Tooltip,
        ]}
      />
      <SeriesCollectionDirective>
        {data.chartConfig.map((series, index) => (
          <SeriesDirective
            key={index}
            dataSource={data.chartData}
            xName={series.xName}
            yName={series.yName}
            name={series.name}
            type={series.type || "Column"} // Default to Column if not specified
            marker={{
              visible: true,
              width: 10,
              height: 10,
            }}
            width={2}
            fill={series.color}
          />
        ))}
      </SeriesCollectionDirective>
    </ChartComponent>
  );
};

export default CustomChart;